export { Head, splideCoreMinCss } from './lib/Head';
export type { Props as HeadProps } from './lib/Head';
